import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FamilyRestroomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"family_restroom"}/>
}
